module.exports = __webpack_public_path__ + "static/media/flutter_app_development.b1ce0033.svg";